import { Injectable } from '@angular/core';
import { BehaviorSubject, firstValueFrom } from 'rxjs';
import { PagedList, RejectionModel } from '../interface';
import { RejectionResourceService } from '../vn-api/api/rejection-resource.service';
import { RejectionFullModel } from '../vn-api/model/rejection-full-model';
import { SaveRejectionRequest } from '../vn-api/model/save-rejection-request';

@Injectable({
  providedIn: 'root'
})
export class HxRejectionService {
  private rejectionSubject = new BehaviorSubject<RejectionModel | undefined>(undefined);
  readonly rejectionObs = this.rejectionSubject.asObservable();

  private storeId?: number;
  private cityId?: number;
  private date?: string;
  private rejection?: RejectionFullModel;
  private orderId?: number;

  constructor(private rejectionApi: RejectionResourceService) {
  }

  initRejection(opts: {storeId?: number, cityId?: number, date?: string, orderId?: number}): void {
    this.storeId = opts.storeId;
    this.cityId = opts.cityId;
    this.date = opts.date;
    this.orderId = opts.orderId;
  }

  setRejection(rejection: RejectionFullModel): void {
    this.rejection = rejection;
  }

  async getRejectionList(params?: {
    date?: string;
    fromTime?: string;
    toTime?: string;
    cityId?: number;
    storeId?: number;
    page?: number;
    limit?: number;
    deliveryExists?: boolean;
    pickupExists?: boolean;
    decorExists?: boolean;
    promoExists?: boolean;
    query?: string;
  }): Promise<PagedList<RejectionFullModel>> {
    return firstValueFrom(this.rejectionApi.getRejections(
      params?.cityId,
      params?.date,
      params?.decorExists,
      params?.deliveryExists,
      params?.limit,
      params?.page,
      params?.pickupExists,
      undefined,
      params?.promoExists,
      params?.query,
      params?.storeId,
    ));
  }

  async saveRejection(request: RejectionModel | undefined): Promise<RejectionFullModel> {
    const body = (request ?? {}) as SaveRejectionRequest;
    if (this.rejection) {
      return firstValueFrom(this.rejectionApi.updateRejection(this.rejection.id, body));
    }
    return firstValueFrom(this.rejectionApi.createRejection(body));
  }

  prepareRejection(request: Partial<RejectionModel>) {
    request.date = this.date;
    request.storeId = this.storeId;
    request.cityId = this.cityId;
    request.orderId = this.orderId;
    this.rejectionSubject.next(request as RejectionModel);
  }

  clearRejection() {
    this.rejectionSubject.next(undefined);
    this.storeId = undefined;
    this.cityId = undefined;
    this.date = undefined;
    this.rejection = undefined;
  }

  getStoreId(): number | undefined {
    return this.storeId;
  }

  getCityId(): number | undefined {
    return this.cityId;
  }

  getDate(): string | undefined {
    return this.date;
  }

  getOrderId(): number | undefined {
    return this.orderId;
  }
}
